/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurchasePlatformOrderFeeVo
 */
export interface PurchasePlatformOrderFeeVo {
    /**
     * 购买商品的所在平台的订单号
     * @type {string}
     * @memberof PurchasePlatformOrderFeeVo
     */
    purchasePlatformOrderNo?: string;
    /**
     * 商品总金额
     * @type {number}
     * @memberof PurchasePlatformOrderFeeVo
     */
    totalPrice?: number;
    /**
     * 中国国内运费
     * @type {number}
     * @memberof PurchasePlatformOrderFeeVo
     */
    totalChinaDomesticShippingFee?: number;
    /**
     * 采购附加费
     * @type {number}
     * @memberof PurchasePlatformOrderFeeVo
     */
    totalAdditionalFee?: number;
    /**
     * 税费
     * @type {number}
     * @memberof PurchasePlatformOrderFeeVo
     */
    totalPurchaseTaxFee?: number;
    /**
     * 税点
     * @type {number}
     * @memberof PurchasePlatformOrderFeeVo
     */
    purchaseTax?: number;
}

/**
 * Check if a given object implements the PurchasePlatformOrderFeeVo interface.
 */
export function instanceOfPurchasePlatformOrderFeeVo(value: object): value is PurchasePlatformOrderFeeVo {
    return true;
}

export function PurchasePlatformOrderFeeVoFromJSON(json: any): PurchasePlatformOrderFeeVo {
    return PurchasePlatformOrderFeeVoFromJSONTyped(json, false);
}

export function PurchasePlatformOrderFeeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchasePlatformOrderFeeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'purchasePlatformOrderNo': json['purchasePlatformOrderNo'] == null ? undefined : json['purchasePlatformOrderNo'],
        'totalPrice': json['totalPrice'] == null ? undefined : json['totalPrice'],
        'totalChinaDomesticShippingFee': json['totalChinaDomesticShippingFee'] == null ? undefined : json['totalChinaDomesticShippingFee'],
        'totalAdditionalFee': json['totalAdditionalFee'] == null ? undefined : json['totalAdditionalFee'],
        'totalPurchaseTaxFee': json['totalPurchaseTaxFee'] == null ? undefined : json['totalPurchaseTaxFee'],
        'purchaseTax': json['purchaseTax'] == null ? undefined : json['purchaseTax'],
    };
}

export function PurchasePlatformOrderFeeVoToJSON(json: any): PurchasePlatformOrderFeeVo {
    return PurchasePlatformOrderFeeVoToJSONTyped(json, false);
}

export function PurchasePlatformOrderFeeVoToJSONTyped(value?: PurchasePlatformOrderFeeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'purchasePlatformOrderNo': value['purchasePlatformOrderNo'],
        'totalPrice': value['totalPrice'],
        'totalChinaDomesticShippingFee': value['totalChinaDomesticShippingFee'],
        'totalAdditionalFee': value['totalAdditionalFee'],
        'totalPurchaseTaxFee': value['totalPurchaseTaxFee'],
        'purchaseTax': value['purchaseTax'],
    };
}

